import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { veiculosAPI } from "../../servicos/veiculos";
import Topo from "../Topo/topo";
import ListagemFeedback from "../Listagem/feedback";
import ListagemOpcoes from "../Listagem/opcoes";
import ColumnToggleDropdown from "../ui/column-toggle-dropdown";
import { DataTable } from "../ui/data-table";
import UsuarioCard from "./card";
import Paginacao from "../Listagem/paginacao";
import { useDebitosLote } from "../Debitos/Lote/DebitosLoteContext";
import {
  CONSULTA_TIPOS_ORDEM,
  CONSULTA_TIPOS_ROTULOS,
  consultaTiposToArray,
  formatarConsultaTiposResumo,
  normalizarConsultaTipos,
} from "../Debitos/Lote/consultaTiposUtils";

const DETRAN_PAGE_SIZE = 50;
const TIPOS_CONSULTA_STORAGE_KEY = "debitoLoteTiposConsultaPreferencia";

const carregarPreferenciaConsultaTipos = () => {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const salvo = window.localStorage.getItem(TIPOS_CONSULTA_STORAGE_KEY);
    if (!salvo) {
      return null;
    }
    const parsed = JSON.parse(salvo);
    return normalizarConsultaTipos(parsed);
  } catch (_erro) {
    return null;
  }
};

const salvarPreferenciaConsultaTipos = (valor) => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(
      TIPOS_CONSULTA_STORAGE_KEY,
      JSON.stringify(normalizarConsultaTipos(valor)),
    );
  } catch (_erro) {
    // Ignora falhas de persistência local
  }
};

const formatValue = (valor) => {
  if (valor === null || valor === undefined || valor === "") {
    return "-";
  }
  if (typeof valor === "number") {
    return valor.toString();
  }
  return String(valor);
};

const RESTRICAO_ROTULOS = {
  descrTipoRestricao: "restrição",
  numeroRestricao: "número",
  descrSituacaoRestricao: "situação",
  nomeAgenteFinanceiro: "agente financeiro",
  cnpjAgenteFinanceiro: "cnpj agente financeiro",
  numeroContrato: "número contrato",
  dataContrato: "data contrato",
};

function VeiculoTabela() {
  const breadcrumbs = ["Home", "Veículos"];
  const navigate = useNavigate();

  const [exibeErro, setExibeErro] = useState(false);
  const [mensagemErro, setMensagemErro] = useState("");
  const [exibeSucesso, setExibeSucesso] = useState(false);
  const [mensagemSucesso, setMensagemSucesso] = useState("");

  const [loading, setLoading] = useState(false);
  const [veiculosSistema, setVeiculosSistema] = useState([]);
  const [veiculosDetran, setVeiculosDetran] = useState([]);
  const [detranPagina, setDetranPagina] = useState(1);
  const [detranMeta, setDetranMeta] = useState(null);
  const [detranHabilitado, setDetranHabilitado] = useState(true);
  const [detranLoading, setDetranLoading] = useState(false);

  const [filtroTexto, setFiltroTexto] = useState("");
  const [page, setPage] = useState(1);

  const [colunasVisiveis, setColunasVisiveis] = useState({
    origem: true,
    placa: true,
    renavam: true,
    chassi: true,
    situacao: true,
    status: true,
    acoes: true,
  });

  const [detalheSelecionado, setDetalheSelecionado] = useState(null);
  const [renavamsSelecionados, setRenavamsSelecionados] = useState({});

  const {
    consultarDebitosLote,
    abrirPainel: abrirPainelDebitos,
    carregando: carregandoDebitosLote,
    status: statusDebitosLote,
    consulta: consultaDebitosLote,
  } = useDebitosLote();
  const consultaTiposDoContexto = consultaDebitosLote?.parametros?.consultaTipos;
  const [tiposConsultaSelecionados, setTiposConsultaSelecionados] = useState(() => {
    const preferencia = carregarPreferenciaConsultaTipos();
    if (preferencia) {
      return preferencia;
    }
    if (consultaTiposDoContexto) {
      return normalizarConsultaTipos(consultaTiposDoContexto);
    }
    return normalizarConsultaTipos(null);
  });
  useEffect(() => {
    salvarPreferenciaConsultaTipos(tiposConsultaSelecionados);
  }, [tiposConsultaSelecionados]);
  const consultaTiposResumo = formatarConsultaTiposResumo(tiposConsultaSelecionados);
  const normalizarRenavamSelecionado = (valor) => {
    const texto = (valor ?? "").toString().trim();
    if (!texto) {
      return "";
    }
    const numeros = texto.replace(/\D+/g, "");
    if (numeros) {
      const semZeros = numeros.replace(/^0+/, "");
      return semZeros || "0";
    }
    return texto.toUpperCase();
  };
  const renavamsSelecionadosLista = useMemo(
    () => Object.values(renavamsSelecionados),
    [renavamsSelecionados],
  );
  const renavamsSelecionadosUnicos = useMemo(() => {
    const vistos = new Set();
    return renavamsSelecionadosLista.reduce((acumulado, item) => {
      const renavamNormalizado = item.renavamNormalizado || normalizarRenavamSelecionado(item.renavam);
      if (!renavamNormalizado || vistos.has(renavamNormalizado)) {
        return acumulado;
      }
      vistos.add(renavamNormalizado);
      acumulado.push({
        ...item,
        renavamNormalizado,
      });
      return acumulado;
    }, []);
  }, [renavamsSelecionadosLista]);
  const renavamsDuplicadosResumo = useMemo(() => {
    const mapa = new Map();
    renavamsSelecionadosLista.forEach((item) => {
      const renavamNormalizado = item.renavamNormalizado || normalizarRenavamSelecionado(item.renavam);
      if (!renavamNormalizado) {
        return;
      }
      if (!mapa.has(renavamNormalizado)) {
        mapa.set(renavamNormalizado, {
          renavam: renavamNormalizado,
          quantidade: 0,
          placas: new Set(),
        });
      }
      const registro = mapa.get(renavamNormalizado);
      registro.quantidade += 1;
      const placaNormalizada = (item.placa || "").toString().trim().toUpperCase();
      if (placaNormalizada) {
        registro.placas.add(placaNormalizada);
      } else if (item.renavam) {
        registro.placas.add(item.renavam);
      } else {
        registro.placas.add(renavamNormalizado);
      }
    });
    return Array.from(mapa.values()).filter((item) => item.quantidade > 1);
  }, [renavamsSelecionadosLista]);
  const placasDuplicadasLista = useMemo(() => {
    const agregadas = new Set();
    renavamsDuplicadosResumo.forEach((item) => {
      const valores = item.placas.size > 0 ? Array.from(item.placas) : [item.renavam];
      valores.forEach((valor) => agregadas.add(valor));
    });
    return Array.from(agregadas).sort();
  }, [renavamsDuplicadosResumo]);
  const carregarVeiculos = useCallback(async (pagina = 1) => {
    setLoading(true);
    setDetranLoading(true);
    setExibeErro(false);
    setMensagemErro("");
    try {
      const fi100_key_public = sessionStorage.getItem("key");
      if (!fi100_key_public) {
        throw new Error("SISTEMA: Sessão expirada. Faça um novo login.");
      }
      const { data } = await veiculosAPI.get(`/${fi100_key_public}`, {
        params: { pagina },
      });
      setVeiculosSistema(data?.veiculosSistema?.registros ?? []);
      setVeiculosDetran(data?.veiculosDetran?.registros ?? []);
      setDetranMeta(data?.veiculosDetran?.pagina ?? null);
      setDetranHabilitado(Boolean(data?.veiculosDetran?.habilitado));
      setPage(1);
    } catch (erro) {
      const mensagem =
        erro?.response?.data?.message ||
        erro?.message ||
        "Ops! Não foi possível carregar os veículos.";
      setExibeErro(true);
      setMensagemErro(mensagem);
    } finally {
      setLoading(false);
      setDetranLoading(false);
    }
  }, []);

  useEffect(() => {
    carregarVeiculos(detranPagina);
  }, [carregarVeiculos, detranPagina]);

  const Editar = useCallback(
    (id) => {
      navigate(`/filiado/veiculo/editar/${id}`);
    },
    [navigate],
  );

  const Emplacar = useCallback(
    (id) => {
      navigate(`/filiado/veiculo/emplacar/${id}`);
    },
    [navigate],
  );

  const Debitos = useCallback(
    (id) => {
      navigate(`/filiado/veiculo/debito/${id}`);
    },
    [navigate],
  );

  const atualizarStatusVeiculo = useCallback(
    async ({ endpoint, payload, sucesso }) => {
      setExibeSucesso(false);
      setMensagemSucesso("");
      setExibeErro(false);
      setMensagemErro("");
      try {
        await veiculosAPI.patch(endpoint, payload);
        setExibeSucesso(true);
        setMensagemSucesso(sucesso);
        carregarVeiculos(detranPagina);
      } catch (erro) {
        const mensagem =
          erro?.response?.data?.message ||
          erro?.message ||
          "Ops! Não foi possível atualizar o veículo.";
        setExibeErro(true);
        setMensagemErro(mensagem);
      }
    },
    [carregarVeiculos, detranPagina],
  );

  const DesativarVeiculo = useCallback(
    (key) => {
      const fi100_key_public = sessionStorage.getItem("key");
      atualizarStatusVeiculo({
        endpoint: "/desativar",
        payload: {
          fi100_key: fi100_key_public,
          ve100_key: key,
        },
        sucesso: "Veículo desativado com sucesso.",
      });
    },
    [atualizarStatusVeiculo],
  );

  const AtivarVeiculo = useCallback(
    (key) => {
      const fi100_key_public = sessionStorage.getItem("key");
      atualizarStatusVeiculo({
        endpoint: "/reativar",
        payload: {
          fi100_key: fi100_key_public,
          ve100_key: key,
        },
        sucesso: "Veículo ativado com sucesso.",
      });
    },
    [atualizarStatusVeiculo],
  );

  const buscaNormalizada = useMemo(
    () => filtroTexto.trim().toLowerCase(),
    [filtroTexto],
  );

  const aplicaFiltro = useCallback(
    (lista, origem) => {
      const rows = lista.map((item, index) => {
        if (origem === "SISTEMA") {
          const idSistema =
            item.metadados?.chavePublica ||
            (item.renavam ? `sistema-${item.renavam}` : `sistema-${index}`);
          return {
            ...item,
            id: idSistema,
            origemLabel: "SISTEMA",
            isDetran: false,
          };
        }
        const idDetranBase = item.identificador || item.renavam || `idx-${index}`;
        const idDetran = `detran-${idDetranBase}`;
        return {
          ...item,
          id: idDetran,
          origemLabel: "DETRANPR",
          isDetran: true,
        };
      });
      if (!buscaNormalizada) {
        return rows;
      }
      return rows.filter((item) => {
        const termos = [
          item.placa,
          item.renavam,
          item.chassi,
          item.situacao,
          item.tipoVeiculo,
          item.categoria,
          item.marcaModelo,
          item.origemLabel,
          item.metadados?.chaveNfe,
          item.metadados?.chavePublica,
          item.restricoes ? JSON.stringify(item.restricoes) : null,
        ];
        return termos.some((termo) =>
          (termo || "").toString().toLowerCase().includes(buscaNormalizada),
        );
      });
    },
    [buscaNormalizada],
  );

  const baseFiltrados = useMemo(
    () => aplicaFiltro(veiculosSistema, "SISTEMA"),
    [aplicaFiltro, veiculosSistema],
  );
  const detranFiltrados = useMemo(
    () => aplicaFiltro(veiculosDetran, "DETRAN"),
    [aplicaFiltro, veiculosDetran],
  );

  useEffect(() => {
    setPage(1);
    setDetranPagina(1);
  }, [filtroTexto]);

  const linhasPaginadas = useMemo(() => {
    const paginaDetran = page - 1;
    const resultado = [];

    if (page === 1 && baseFiltrados.length) {
      resultado.push(
        ...baseFiltrados.map((item, index) => ({
          ...item,
          rowIndex: index + 1,
        })),
      );
    }

    const detranInicio = paginaDetran * DETRAN_PAGE_SIZE;
    const detranFim = detranInicio + DETRAN_PAGE_SIZE;
    const detranSlice = detranFiltrados
      .slice(detranInicio, detranFim)
      .map((item, index) => {
        const offset =
          page === 1 ? baseFiltrados.length : baseFiltrados.length + (page - 1) * DETRAN_PAGE_SIZE;
        return {
          ...item,
          rowIndex: offset + index + 1,
        };
      });
    resultado.push(...detranSlice);

    return resultado;
  }, [baseFiltrados, detranFiltrados, page]);

  const selecionaveisPagina = useMemo(
    () => linhasPaginadas.filter((item) => item.renavam),
    [linhasPaginadas],
  );
  const todosSelecionadosPagina =
    selecionaveisPagina.length > 0 &&
    selecionaveisPagina.every((item) => Boolean(item?.id && renavamsSelecionados[item.id]));
  const algumSelecionadoPagina = selecionaveisPagina.some(
    (item) => Boolean(item?.id && renavamsSelecionados[item.id]),
  );
  const totalSelecionados = renavamsSelecionadosLista.length;
  const totalDuplicados = Math.max(0, totalSelecionados - renavamsSelecionadosUnicos.length);
  const consultaDebitosEmAndamento =
    statusDebitosLote === "loading" || Boolean(carregandoDebitosLote);
  const consultaTiposSelecionadosLista = useMemo(
    () => consultaTiposToArray(tiposConsultaSelecionados),
    [tiposConsultaSelecionados],
  );
  const handleToggleTipoConsulta = useCallback(
    (tipo) => {
      setTiposConsultaSelecionados((prev) => {
        const proximo = {
          ...prev,
          [tipo]: !prev?.[tipo],
        };
        if (consultaTiposToArray(proximo).length === 0) {
          return prev;
        }
        return proximo;
      });
    },
    [],
  );

  const selecionarPaginaAtual = useCallback(
    (marcar) => {
      setRenavamsSelecionados((prev) => {
        const atualizado = { ...prev };
        if (marcar) {
          selecionaveisPagina.forEach((item) => {
            if (!item?.id) {
              return;
            }
            const renavamNormalizado = normalizarRenavamSelecionado(item.renavam);
            atualizado[item.id] = {
              id: item.id,
              renavam: item.renavam,
              renavamNormalizado,
              placa: item.placa || "",
              origem: item.origemLabel,
            };
          });
        } else {
          selecionaveisPagina.forEach((item) => {
            if (!item?.id) {
              return;
            }
            delete atualizado[item.id];
          });
        }
        return atualizado;
      });
    },
    [selecionaveisPagina],
  );

  const toggleRenavamSelecionado = useCallback(
    (row) => {
      if (!row?.renavam) {
        setExibeErro(true);
        setMensagemErro("Apenas veículos com RENAVAM podem ser consultados em lote.");
        return;
      }
      setExibeErro(false);
      setMensagemErro("");
      const chaveSelecao = row?.id;
      if (!chaveSelecao) {
        return;
      }
      setRenavamsSelecionados((prev) => {
        const atualizado = { ...prev };
        if (atualizado[chaveSelecao]) {
          delete atualizado[chaveSelecao];
        } else {
          const renavamNormalizado = normalizarRenavamSelecionado(row.renavam);
          atualizado[chaveSelecao] = {
            id: chaveSelecao,
            renavam: row.renavam,
            renavamNormalizado,
            placa: row.placa || "",
            origem: row.origemLabel,
          };
        }
        return atualizado;
      });
    },
    [setExibeErro, setMensagemErro],
  );

  const limparSelecao = useCallback(() => {
    setRenavamsSelecionados({});
  }, []);

  const consultarDebitosSelecionados = useCallback(async () => {
    setExibeErro(false);
    setMensagemErro("");
    setExibeSucesso(false);
    setMensagemSucesso("");

    if (totalSelecionados === 0) {
      setExibeErro(true);
      setMensagemErro("Selecione ao menos um veículo com RENAVAM para consultar débitos em lote.");
      return;
    }

    if (consultaTiposSelecionadosLista.length === 0) {
      setExibeErro(true);
      setMensagemErro("Escolha ao menos um tipo de débito para consultar (IPVA, Multas ou Licenciamento).");
      return;
    }

    try {
      const veiculosPayload = renavamsSelecionadosUnicos.map((item) => ({
        renavam: item.renavam,
        placa: item.placa || "",
      }));
      const renavamsPayload = veiculosPayload.map((item) => item.renavam);
      await consultarDebitosLote({
        veiculos: veiculosPayload,
        renavams: renavamsPayload,
        somenteAnterior: false,
        somenteMulta: false,
        filtroMulta: 1,
        tiposConsulta: tiposConsultaSelecionados,
      });
      setExibeSucesso(true);
      setMensagemSucesso("Consulta de débitos em lote enviada. Abra o painel global para acompanhar o retorno.");
      abrirPainelDebitos();
    } catch (erro) {
      setExibeErro(true);
      setMensagemErro(erro?.message || "Não foi possível consultar os débitos em lote.");
    }
  }, [
    abrirPainelDebitos,
    consultarDebitosLote,
    renavamsSelecionadosUnicos,
    setExibeErro,
    setExibeSucesso,
    setMensagemErro,
    setMensagemSucesso,
    consultaTiposSelecionadosLista,
    tiposConsultaSelecionados,
    totalSelecionados,
  ]);

  const PaginationControls = ({
    onPrevious,
    onNext,
    disablePrevious = false,
    disableNext = false,
    className = "",
  }) => (
    <div class={`tw-flex tw-gap-2 ${className}`}>
      <button
        type="button"
        class={`btn btn-secondary btn-sm ${disablePrevious ? "btn-disabled" : ""}`}
        disabled={disablePrevious}
        onClick={onPrevious}
      >
        Página anterior
      </button>
      <button
        type="button"
        class={`btn btn-secondary btn-sm ${disableNext ? "btn-disabled" : ""}`}
        disabled={disableNext}
        onClick={onNext}
      >
        Próxima página
      </button>
    </div>
  );

  const abrirDetalhes = useCallback((row) => {
    setDetalheSelecionado(row);
  }, []);

  const fecharDetalhes = useCallback(() => {
    setDetalheSelecionado(null);
  }, []);

  const formatarDataBrasileira = (valor) => {
    if (!valor) return "";
    const data = new Date(valor);
    if (Number.isNaN(data.getTime())) {
      return valor;
    }
    return data.toLocaleDateString("pt-BR");
  };

  const formatRestricoes = useCallback((valor) => {
    if (!valor || typeof valor !== "object") {
      return [];
    }
    if (Array.isArray(valor)) {
      return valor.flatMap((item, index) => {
        const nested = formatRestricoes(item);
        if (nested.length) {
          return nested;
        }
        return [
          {
            chave: `Restrição ${index + 1}`,
            valor: typeof item === "object" ? JSON.stringify(item) : formatValue(item),
          },
        ];
      });
    }
    return Object.entries(valor).map(([chave, campoValor]) => {
      if (typeof campoValor === "object" && campoValor !== null) {
        const rotulo = RESTRICAO_ROTULOS[chave] || chave;
        const tratado =
          typeof campoValor === "number"
            ? campoValor.toString()
            : typeof campoValor === "object" && campoValor !== null
            ? JSON.stringify(campoValor)
            : campoValor;
        return {
          chave: rotulo,
          valor: formatValue(tratado),
        };
      }
      const isDateField = /data/iu.test(chave);
      const rotulo = RESTRICAO_ROTULOS[chave] || chave;
      return {
        chave: rotulo,
        valor: isDateField ? formatarDataBrasileira(campoValor) : formatValue(campoValor),
      };
    });
  }, []);

  const colunasBase = useMemo(
    () => [
      {
        id: "selecionar",
        header: () => (
          <input
            type="checkbox"
            class="form-check-input"
            aria-label="Selecionar veículos desta página"
            checked={todosSelecionadosPagina && selecionaveisPagina.length > 0}
            ref={(input) => {
              if (input) {
                input.indeterminate = !todosSelecionadosPagina && algumSelecionadoPagina;
              }
            }}
            onChange={() => selecionarPaginaAtual(!todosSelecionadosPagina)}
          />
        ),
        label: "Selecionar",
        canHide: false,
        className: "tw-w-[50px] tw-align-top",
        headerClassName: "tw-w-[50px]",
        cell: ({ row }) => {
          const desabilitado = !row.renavam;
          return (
            <input
              type="checkbox"
              class="form-check-input"
              disabled={desabilitado}
              checked={!!(row?.id && renavamsSelecionados[row.id])}
              onChange={() => toggleRenavamSelecionado(row)}
              aria-label={`Selecionar ${row.placa || row.renavam || row.id}`}
              title={
                desabilitado
                  ? "RENAVAM não disponível para consulta em lote."
                  : "Selecionar veículo para consulta em lote."
              }
            />
          );
        },
      },
      {
        id: "indice",
        header: () => "#",
        label: "#",
        canHide: false,
        className: "tw-align-top tw-w-[60px] tw-text-xs tw-font-semibold tw-text-slate-500",
        cell: ({ row }) => <span>{row.rowIndex}</span>,
      },
      {
        id: "origem",
        header: () => "Origem",
        label: "Origem",
        canHide: false,
        className: "tw-align-top tw-w-[120px]",
        cell: ({ row }) => (
          <span
            class={`tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold ${
              row.isDetran
                ? "tw-bg-amber-100 tw-text-amber-800"
                : "tw-bg-emerald-100 tw-text-emerald-800"
            }`}
          >
            {row.origemLabel}
          </span>
        ),
      },
      {
        id: "placa",
        header: () => "Placa",
        label: "Placa",
        className: "tw-align-top",
        cell: ({ row }) => (
          <span class="tw-font-semibold tw-uppercase">{formatValue(row.placa)}</span>
        ),
      },
      {
        id: "renavam",
        header: () => "Renavam",
        label: "Renavam",
        className: "tw-align-top",
        cell: ({ row }) => <span>{formatValue(row.renavam)}</span>,
      },
      {
        id: "chassi",
        header: () => "Chassi",
        label: "Chassi",
        className: "tw-align-top tw-break-all",
        cell: ({ row }) => (
          <span class="tw-font-mono tw-text-sm">{formatValue(row.chassi)}</span>
        ),
      },
      {
        id: "situacao",
        header: () => "Situação",
        label: "Situação",
        className: "tw-align-top",
        cell: ({ row }) => (
          <span class="tw-text-sm tw-text-slate-700 dark:tw-text-slate-200">
            {formatValue(row.situacao)}
          </span>
        ),
      },
      {
        id: "status",
        header: () => "Status",
        label: "Status",
        className: "tw-align-top tw-w-[120px]",
        cell: ({ row }) => {
          if (row.isDetran) {
            return <span class="tw-text-slate-500">-</span>;
          }
          return (
            <span
              class={`tw-inline-flex tw-rounded-full tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold ${
                row.ativo
                  ? "tw-bg-emerald-100 tw-text-emerald-800"
                  : "tw-bg-rose-100 tw-text-rose-700"
              }`}
            >
              {row.ativo ? "Ativado" : "Desativado"}
            </span>
          );
        },
      },
      {
        id: "acoes",
        header: () => "Ações",
        label: "Ações",
        canHide: false,
        className: "tw-align-top tw-w-[100px]",
        cell: ({ row }) => (
          <button
            type="button"
            class="btn btn-primary btn-sm"
            onClick={() => abrirDetalhes(row)}
          >
            Detalhes
          </button>
        ),
      },
    ],
    [
      abrirDetalhes,
      algumSelecionadoPagina,
      renavamsSelecionados,
      selecionarPaginaAtual,
      selecionaveisPagina,
      todosSelecionadosPagina,
      toggleRenavamSelecionado,
    ],
  );

  const colunasTabela = useMemo(
    () => colunasBase.filter((coluna) => colunasVisiveis[coluna.id] !== false),
    [colunasBase, colunasVisiveis],
  );

  const toggleColuna = useCallback(
    (colunaId) => {
      const coluna = colunasBase.find((col) => col.id === colunaId);
      if (coluna?.canHide === false) {
        return;
      }
      setColunasVisiveis((prev) => ({
        ...prev,
        [colunaId]: prev[colunaId] === false,
      }));
    },
    [colunasBase],
  );

  const detranPaginaAtual = detranMeta?.paginaAtual ?? detranMeta?.paginaSolicitada ?? detranPagina;
  const detranTotalPaginas = detranMeta?.totalPaginas ?? null;
  const podeVoltarDetran = detranPagina > 1;
  const podeAvancarDetran =
    detranHabilitado &&
    (detranTotalPaginas ? detranPagina < detranTotalPaginas : veiculosDetran.length > 0);

  const handleDetranAvancar = useCallback(
    (incremento) => {
      if (detranLoading) {
        return;
      }
      const proximaPagina = Math.max(1, detranPagina + incremento);
      if (proximaPagina === detranPagina) {
        return;
      }
      setDetranPagina(proximaPagina);
      setPage(proximaPagina);
    },
    [detranLoading, detranPagina],
  );

  return (
    <div class="row">
      <div class="container">
        <div class="topo-wrapper">
          <Topo titulo="Veículos" breadcrumbs={breadcrumbs} btnincluir={true} destino="/filiado/veiculo/novo" admin={false} />
          <ListagemFeedback
            displayErro={exibeErro}
            mensagemErro={mensagemErro}
            displaySucesso={exibeSucesso}
            mensagemSucesso={mensagemSucesso}
          />
        </div>
      </div>
      <ListagemOpcoes esconderTamanhoPagina={true} esconderOpcaoFiltro={true} esconderCampoFiltro={true} />
      <div class="row row-padding-conteudo">
        <div class="col-sm-12">
          <div class="card card-body tw-space-y-2 tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/90 tw-text-sm tw-text-slate-700 tw-shadow-sm dark:tw-border-slate-700 dark:tw-bg-slate-900/70 dark:tw-text-slate-200">
            <p>
              Nesta aba Veículos, traremos os carros que foram cadastrados pelo sistema e agora também traremos todos os carros ligados ao seu CNPJ
              diretamente da base do DetranPR e seu funcionamento / tempo de leitura dependerá da velocidade de entrega destes dados pelo DetranPR.
            </p>
            <p class="tw-mb-0">Ao clicar em Detalhes será possível verificar os débitos deste veículo.</p>
          </div>
        </div>
      </div>

      <div class="row row-padding-conteudo">
        <div class="col-12">
          <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-4 tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/90 tw-p-4 tw-shadow-sm dark:tw-border-slate-700 dark:tw-bg-slate-900/70">
            <div class="tw-flex tw-flex-col tw-gap-2">
              <span class="tw-text-xs tw-uppercase tw-text-slate-500">Consulta DETRAN</span>
              {detranHabilitado ? (
                <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-3">
                  <div class="tw-flex tw-items-center tw-gap-2">
                    <span class="tw-text-sm tw-font-semibold">Página {detranPaginaAtual}</span>
                    {detranLoading && (
                      <span class="tw-inline-flex tw-items-center tw-gap-1 tw-text-xs tw-text-slate-500">
                        <span class="tw-inline-flex tw-h-2 tw-w-2 tw-animate-ping tw-rounded-full tw-bg-amber-500" />
                        Consultando...
                      </span>
                    )}
                  </div>
                  <PaginationControls
                    disablePrevious={!podeVoltarDetran || detranLoading}
                    disableNext={!podeAvancarDetran || detranLoading}
                    onPrevious={() => handleDetranAvancar(-1)}
                    onNext={() => handleDetranAvancar(1)}
                  />
                </div>
              ) : (
                <p class="tw-text-xs tw-text-slate-500">
                  Vincule o Token D para consultar a frota diretamente no DETRAN.
                </p>
              )}
            </div>
            <div
              class={`tw-inline-flex tw-h-min tw-items-center tw-justify-center tw-rounded-full tw-px-3 tw-py-1 tw-text-xs tw-font-semibold ${
                detranHabilitado ? "tw-bg-emerald-100 tw-text-emerald-800" : "tw-bg-rose-100 tw-text-rose-600"
              }`}
            >
              {detranHabilitado ? "DETRAN habilitado" : "DETRAN desabilitado"}
            </div>
          </div>
        </div>
      </div>

      <div class="row row-padding-conteudo">
        <div class="col-12">
          <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-4 tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/90 tw-p-4 tw-shadow-sm dark:tw-border-slate-700 dark:tw-bg-slate-900/70">
            <div class="tw-flex tw-min-w-[240px] tw-flex-1 tw-items-center tw-gap-3">
              <label for="filtro-veiculos" class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600 dark:tw-text-slate-300">
                Pesquisa:
              </label>
              <input
                id="filtro-veiculos"
                type="search"
                class="form-control tw-h-11 tw-flex-1 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/95 tw-px-3 tw-py-2 tw-text-sm tw-text-slate-700 placeholder:tw-text-slate-400 focus:tw-border-indigo-400 focus:tw-ring-2 focus:tw-ring-indigo-300 dark:tw-border-slate-700 dark:tw-!bg-slate-900/70 dark:tw-text-slate-100 dark:placeholder:tw-text-slate-500 dark:focus:tw-ring-indigo-400/40"
                placeholder="Busque por placa, chassi, RENAVAM..."
                value={filtroTexto}
                onChange={(evento) => setFiltroTexto(evento.target.value)}
              />
            </div>
            <div class="tw-flex tw-items-center tw-gap-4">
              <ColumnToggleDropdown
                colunas={colunasBase.map((coluna) => ({ id: coluna.id, label: coluna.label || coluna.header(), canHide: coluna.canHide }))}
                visibilidade={colunasVisiveis}
                onToggle={toggleColuna}
                label="Colunas"
                align="end"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row row-padding-conteudo">
        <div class="col-12">
          <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3 tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-slate-50/80 tw-p-4 tw-shadow-sm dark:tw-border-slate-700 dark:tw-bg-slate-900/70">
              <div class="tw-flex tw-flex-col tw-gap-1">
                <span class="tw-text-xs tw-font-semibold tw-uppercase tw-text-slate-500">Consulta de débitos em lote</span>
                <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
                  <span class="tw-text-sm tw-font-semibold tw-text-slate-800 dark:tw-text-slate-100">
                    {totalSelecionados} selecionado(s)
                  </span>
                  {totalDuplicados > 0 && (
                    <span class="tw-text-[11px] tw-font-semibold tw-text-amber-600 dark:tw-text-amber-300">
                      {totalDuplicados} duplicado(s) ignorado(s)
                      {placasDuplicadasLista.length > 0 && (
                        <>: {placasDuplicadasLista.join(", ")}</>
                      )}
                    </span>
                  )}
                  {algumSelecionadoPagina && (
                    <span class="tw-text-xs tw-text-slate-500 dark:tw-text-slate-300">
                      {todosSelecionadosPagina ? "Todos desta página selecionados" : "Seleção parcial nesta página"}
                    </span>
                  )}
                  {consultaDebitosEmAndamento && (
                    <span class="tw-inline-flex tw-items-center tw-gap-1 tw-text-xs tw-text-slate-500 dark:tw-text-slate-300">
                      <span class="tw-inline-flex tw-h-2 tw-w-2 tw-animate-ping tw-rounded-full tw-bg-amber-500" />
                      Consultando débitos...
                    </span>
                  )}
                </div>
                <p class="tw-m-0 tw-text-xs tw-text-slate-500 dark:tw-text-slate-400">
                  Selecione veículos com RENAVAM na tabela e envie a consulta. O retorno aparecerá no painel global de débitos.
                </p>
                <div class="tw-mt-2 tw-flex tw-flex-wrap tw-items-center tw-gap-2">
                  <span class="tw-text-[11px] tw-font-semibold tw-uppercase tw-text-slate-500 dark:tw-text-slate-400">
                    Blocos consultados:
                  </span>
                  <div class="tw-flex tw-flex-wrap tw-gap-2">
                    {CONSULTA_TIPOS_ORDEM.map((tipo) => {
                      const ativo = Boolean(tiposConsultaSelecionados?.[tipo]);
                      const label = CONSULTA_TIPOS_ROTULOS[tipo];
                      return (
                        <button
                          key={tipo}
                          type="button"
                          class={`tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-border tw-px-3 tw-py-1 tw-text-xs tw-font-semibold transition ${
                            ativo
                              ? "tw-border-indigo-500 tw-bg-indigo-600 tw-text-white tw-shadow-sm"
                              : "tw-border-slate-300 tw-bg-white tw-text-slate-600 hover:tw-border-slate-400 dark:tw-border-slate-600 dark:tw-bg-slate-800 dark:tw-text-slate-200"
                          }`}
                          aria-pressed={ativo}
                          onClick={() => handleToggleTipoConsulta(tipo)}
                        >
                          <span class={`material-symbols-outlined tw-text-[14px] ${ativo ? "" : "tw-opacity-0"}`}>
                            check
                          </span>
                          {label}
                        </button>
                      );
                    })}
                  </div>
                </div>
                <p class="tw-m-0 tw-text-[11px] tw-font-semibold tw-uppercase tw-text-slate-500 dark:tw-text-slate-400">
                  Consultando: {consultaTiposResumo}
                </p>
              </div>
              <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
                <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                onClick={limparSelecao}
                disabled={totalSelecionados === 0}
              >
                Limpar seleção
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                onClick={consultarDebitosSelecionados}
                disabled={totalSelecionados === 0 || consultaDebitosEmAndamento}
              >
                {consultaDebitosEmAndamento ? "Consultando..." : "Consultar débitos em lote"}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row row-padding-conteudo">
        <div class="col-12">
          <div class="veiculos-tabela-wrapper table-responvive">
            {loading && (
              <div class="tw-mb-3 tw-text-sm tw-text-slate-500 dark:tw-text-slate-400">Carregando veículos...</div>
            )}
            <DataTable
              columns={colunasTabela}
              data={linhasPaginadas}
              getRowId={(row) => row.id}
              className="tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-shadow-lg dark:tw-border-slate-800 dark:tw-bg-slate-900"
            />
            <div class="tw-mt-4 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3">
              <span class="tw-text-sm tw-text-slate-600 dark:tw-text-slate-300">
                Navegue para carregar mais registros. Itens exibidos por página: 50 (fixo pelo DETRAN).
              </span>
              <PaginationControls
                disablePrevious={!podeVoltarDetran || detranLoading}
                disableNext={!podeAvancarDetran || detranLoading}
                onPrevious={() => handleDetranAvancar(-1)}
                onNext={() => handleDetranAvancar(1)}
              />
            </div>
          </div>
        </div>
      </div>

      <UsuarioCard />
      <Paginacao esconder={true} />

      {detalheSelecionado && (
        <div class="veiculo-detalhe-modal-backdrop" role="dialog" aria-modal="true">
          <div class="veiculo-detalhe-modal">
            <div class="veiculo-detalhe-modal__header">
              <div>
                <h3>Detalhes do veículo</h3>
                <p>{formatValue(detalheSelecionado.placa)} · {detalheSelecionado.origemLabel}</p>
              </div>
              <button type="button" class="btn-icon" onClick={fecharDetalhes}>
                <span class="material-symbols-outlined">close</span>
              </button>
            </div>
            <div class="veiculo-detalhe-modal__body">
              <div class="veiculo-detalhe-grid">
                <div class="veiculo-detalhe-field">
                  <span>Placa</span>
                  <strong>{formatValue(detalheSelecionado.placa)}</strong>
                </div>
                <div class="veiculo-detalhe-field">
                  <span>RENAVAM</span>
                  <strong>{formatValue(detalheSelecionado.renavam)}</strong>
                </div>
                <div class="veiculo-detalhe-field">
                  <span>Chassi</span>
                  <strong>{formatValue(detalheSelecionado.chassi)}</strong>
                </div>
                <div class="veiculo-detalhe-field">
                  <span>Situação</span>
                  <strong>{formatValue(detalheSelecionado.situacao)}</strong>
                </div>
                <div class="veiculo-detalhe-field">
                  <span>Tipo</span>
                  <strong>{formatValue(detalheSelecionado.tipoVeiculo)}</strong>
                </div>
                <div class="veiculo-detalhe-field">
                  <span>Espécie</span>
                  <strong>{formatValue(detalheSelecionado.especie)}</strong>
                </div>
                <div class="veiculo-detalhe-field">
                  <span>Marca/Modelo</span>
                  <strong>{formatValue(detalheSelecionado.marcaModelo)}</strong>
                </div>
                <div class="veiculo-detalhe-field">
                  <span>Cor</span>
                  <strong>{formatValue(detalheSelecionado.cor)}</strong>
                </div>
                <div class="veiculo-detalhe-field">
                  <span>Combustível</span>
                  <strong>{formatValue(detalheSelecionado.combustivel)}</strong>
                </div>
                <div class="veiculo-detalhe-field">
                  <span>Categoria</span>
                  <strong>{formatValue(detalheSelecionado.categoria)}</strong>
                </div>
                <div class="veiculo-detalhe-field">
                  <span>Município</span>
                  <strong>{formatValue(detalheSelecionado.municipio)}</strong>
                </div>
                <div class="veiculo-detalhe-field">
                  <span>Ano Fab/Modelo</span>
                  <strong>
                    {formatValue(detalheSelecionado.anoFabricacao)}
                    {" / "}
                    {formatValue(detalheSelecionado.anoModelo)}
                  </strong>
                </div>
              </div>

              {!detalheSelecionado.isDetran && (
                <div class="veiculo-detalhe-section">
                  <h4>Metadados do sistema</h4>
                  <div class="veiculo-detalhe-grid">
                    <div class="veiculo-detalhe-field">
                      <span>Código interno</span>
                      <strong>{formatValue(detalheSelecionado.metadados?.codigoVeiculo)}</strong>
                    </div>
                    <div class="veiculo-detalhe-field">
                      <span>Chave pública</span>
                      <strong>{formatValue(detalheSelecionado.metadados?.chavePublica)}</strong>
                    </div>
                    <div class="veiculo-detalhe-field">
                      <span>Chave NF-e</span>
                      <strong>{formatValue(detalheSelecionado.metadados?.chaveNfe)}</strong>
                    </div>
                  </div>
                </div>
              )}

              {detalheSelecionado.restricoes && (
                <div class="veiculo-detalhe-section">
                  <h4>Restrições DETRAN</h4>
                  <div class="veiculo-detalhe-restricoes-list">
                    {formatRestricoes(detalheSelecionado.restricoes).map((item) => (
                      <div key={`${item.chave}-${item.valor}`} class="veiculo-detalhe-restricoes-item">
                        <span>{formatValue(item.chave)}</span>
                        <strong>{formatValue(item.valor)}</strong>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {!detalheSelecionado.isDetran && (
                <div class="veiculo-detalhe-section">
                  <h4>Ações</h4>
                  <div class="tw-flex tw-flex-wrap tw-gap-2">
                    <button type="button" class="btn btn-primary btn-sm" onClick={() => Editar(detalheSelecionado.metadados?.chavePublica)}>
                      Editar
                    </button>
                    <button type="button" class="btn btn-secondary btn-sm" onClick={() => Debitos(detalheSelecionado.metadados?.chavePublica)}>
                      Débitos
                    </button>
                    {detalheSelecionado.metadados?.chaveNfe &&
                      !detalheSelecionado.placa &&
                      !detalheSelecionado.renavam &&
                      detalheSelecionado.chassi && (
                      <button type="button" class="btn btn-secondary btn-sm" onClick={() => Emplacar(detalheSelecionado.metadados?.chavePublica)}>
                        Emplacar
                      </button>
                    )}
                    {detalheSelecionado.ativo ? (
                      <button
                        type="button"
                        class="btn btn-outline-danger btn-sm"
                        onClick={() => DesativarVeiculo(detalheSelecionado.metadados?.chavePublica)}
                      >
                        Desativar
                      </button>
                    ) : (
                      <button
                        type="button"
                        class="btn btn-outline-success btn-sm"
                        onClick={() => AtivarVeiculo(detalheSelecionado.metadados?.chavePublica)}
                      >
                        Ativar
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default VeiculoTabela;
